export enum StepEnum {
    YourDetails = 0,
    Roommates = 1,
    Agreements = 2,
    Payment = 3,
}
